export default __webpack_public_path__ + "static/media/6image.9a1278ef.png";